import { GetParkingMetersQueryVariables } from "@/types/gql/graphql";
import {
  QUERY_CREATE_PARKING_METER,
  QUERY_GET_PARKING_METERS,
  QUERY_REMOVE_PARKING_METER,
  QUERY_UPDATE_PARKING_METER,
} from "@/services/web/api-parking-meter.const";
import { hideGlobalLoading, showGlobalLoading } from "@/hooks/use-global-loading";
import { useContext, useEffect, useMemo } from "react";
import { useTrackedMutation, useTrackedQuery } from "@/hooks/apollo-insights-hooks";

import { CityContext } from "@/contexts/city-context-provider";

export const useQueryParkingMeter = () => {
  const { currentCity } = useContext(CityContext);
  const variables = useMemo<GetParkingMetersQueryVariables>(
    () => ({ cityId: currentCity?.id ?? "" }),
    [currentCity?.id],
  );

  const { data, loading, refetch } = useTrackedQuery(QUERY_GET_PARKING_METERS, {
    actionName: "QueryParkingMeters",
    variables,
    skip: !variables.cityId,
  });

  useEffect(() => {
    if (loading) {
      showGlobalLoading();
    } else {
      hideGlobalLoading();
    }
  }, [loading]);

  const refetchQueriesConfig = [{ query: QUERY_GET_PARKING_METERS, variables }];

  const [createParkingMeter] = useTrackedMutation(QUERY_CREATE_PARKING_METER, {
    actionName: "CreateParkingMeter",
    refetchQueries: refetchQueriesConfig,
    awaitRefetchQueries: true,
  });

  const [updateParkingMeter] = useTrackedMutation(QUERY_UPDATE_PARKING_METER, {
    actionName: "UpdateParkingMeter",
    refetchQueries: refetchQueriesConfig,
    awaitRefetchQueries: true,
  });

  const [removeParkingMeter] = useTrackedMutation(QUERY_REMOVE_PARKING_METER, {
    actionName: "RemoveParkingMeter",
    refetchQueries: refetchQueriesConfig,
    awaitRefetchQueries: true,
  });

  return {
    parkingMeters: data?.getParkingMeters ?? [],
    loading,
    createParkingMeter,
    updateParkingMeter,
    removeParkingMeter,
    refetch,
  };
};
